import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchSimulation } from '../client';
import { useSimulationId } from './useSimulationId';

export function useSetPauseAt() {
  const simId = useSimulationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (pauseAtS: number | null) => {
      await patchSimulation({
        path: { sim_id: simId },
        body: { pause_at_s: pauseAtS },
        throwOnError: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['simulation', simId] });
    },
  });
}
